module.exports = __webpack_public_path__ + "media/images/prediction/special/aokei/img_logo_publisher-7a7c666fe206fc8a06f9926f4828fc84.jpg";